import React from "react";

import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";

import styles from "./AdvancedFilters.module.scss";

export const AdvFiltersDnd = (props) => {
    const { setFilters, children } = props;

    const reorderFilters = (filters, sourceIndex, destinationIndex) => {
        const newList = Array.from(filters);

        const [removed] = newList.splice(sourceIndex, 1);

        newList.splice(destinationIndex, 0, removed);

        return newList;
    };

    const onDragEnd = (data) => {
        setFilters((prev) => {
            return reorderFilters(prev, data.source.index, data.destination.index);
        });
    };

    return (
        <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="advanced-filters" direction="vertical">
                {(provided, snapshot) => (
                    <div className={styles.filtersList} ref={provided.innerRef}>
                        {children}
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>
        </DragDropContext>
    );
};
